import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 *  Intercepts request body of PUT and POST and trim leading and trailing spaces of the strings in JSON
 *  This is global change and applicable for all request bodies
 */
@Injectable()
export class TrimStringSpacesInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;
    if ((req.method === 'PUT' || req.method === 'POST') && req.body) {
      const body = this.trimStringsInJson(req.body);
      request = req.clone({ body });
    }
    return next.handle(request);
  }

  private trimStringsInJson<J>(json: J): J {
    if (json && typeof json === 'object') {
      for (const [key, val] of Object.entries(json)) {
        switch (typeof val) {
          case 'object':
            this.trimStringsInJson(val);
            break;
          case 'string':
            json[key] = val.trim();
            break;
        }
      }
    }
    return json;
  }
}
